import RootLayout from "./RootLayout.svelte";
import IndexPage from "./IndexPage.svelte";
import Prices from "./Prices.svelte";
import AnalyzeInProgress from "./AnalyzeInProgress.svelte";
import AnalyzeFinished from "./AnalyzeFinished.svelte";
import CleanFinished from "./CleanFinished.svelte";
import ProtectionReport from "./ProtectionReport.svelte";
import ProtectionSettings from "./ProtectionSettings.svelte";
import Subscriptions from "./Subscriptions.svelte";

const routes = [
    {
        name: '/demo/',
        component: IndexPage,
        layout: RootLayout,
    },
    {
        name: '/demo/analyze-in-progress',
        component: AnalyzeInProgress,
        layout: RootLayout
    },
    {
        name: '/demo/analyze-finished',
        component: AnalyzeFinished,
        layout: RootLayout
    },
    {
        name: '/demo/clean-finished',
        component: CleanFinished,
        layout: RootLayout
    },
    {
        name: '/demo/protection-report',
        component: ProtectionReport,
        layout: RootLayout
    },
    {
        name: '/demo/protection-settings',
        component: ProtectionSettings,
        layout: RootLayout
    },
    {
        name: '/demo/prices',
        component: Prices,
        layout: RootLayout
    },
    {
        name: '/demo/subscriptions',
        component: Subscriptions,
        layout: RootLayout
    },
];

export { routes };